export default {
  // The blog's title as it appears in the layout header, and in the document
  // <title> tag.
  title: "Reily app",

  author: "Kyle Fang",
  description: "Personal blog by Kyle Fang",

  // The number of posts to a page on the site index.
  indexPageSize: 10
};
